const PREFIX = 'listView:';

const listeners = new Set<() => void>();
let version = 0;

const normalize = (path: string) => path.replace(/\/+$/, '') || '/';

export function subscribeListMemory(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export const listMemoryVersion = () => version;

export function rememberListUrl(listPath: string, url: string) {
  try {
    const key = PREFIX + normalize(listPath);
    if (window.sessionStorage.getItem(key) === url) return;
    window.sessionStorage.setItem(key, url);
  } catch {
    return;
  }
  version++;
  for (const listener of listeners) listener();
}

export function clearListMemory() {
  try {
    const storage = window.sessionStorage;
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key?.startsWith(PREFIX)) keys.push(key);
    }
    for (const key of keys) storage.removeItem(key);
  } catch {
    return;
  }
  version++;
  for (const listener of listeners) listener();
}

export function listUrl(listPath: string): string {
  const path = normalize(listPath);
  try {
    const url = window.sessionStorage.getItem(PREFIX + path);
    if (
      url &&
      (url === path || url.startsWith(`${path}/`) || url.startsWith(`${path}?`))
    ) {
      return url;
    }
  } catch {
    return path;
  }
  return path;
}
